import { checkStripe } from "../Common/StripeChecker";
import { Section } from "../jobs-flow/Section";

export default {
    init() {
        this.markAsPaidCash();
        this.createCharge();
        this.refunds();
        this.removeWarning();
        this.autoRefresh('/payments');
        this.initPagination('/payments');
    },
    markAsPaidCash() {
        $('body').on('click', '.payments__charge-buttons',function(e){
            e.preventDefault();
            let currentElem = $(this);
            let payment_id = currentElem.data('order-id');
            let action = currentElem.data('action');
            let type = currentElem.data('type')

            const paymentRequest = () => {
                $.ajax({
                    type: 'GET',
                    url: '/payments/' + payment_id + '/' + action + (type ? `/${type}` : ''),
                    success: function (response) {
                        // if (action == 'paid-cash') {
                        //     window.location.reload();
                        // } else {
                            $('#ajax_modals_containter').html(response);
                            $('.'+action+'-modal').modal('show');
                            Inputmask("[-]{0,1}9{*}[.]9{0,2}", { placeholder: "-", greedy: false }).mask(`#additional_input`);
                            if (parseFloat($('.charge-modal #total-value').text()) <= 0) {
                                $('.charge-modal .charge-btn').attr('disabled', 'disabled');
                            }
                            if (parseFloat($('.manual-charge-modal .total_value_manual').text()) <= 0) {
                                $('.manual-charge-modal .charge-btn').attr('disabled', 'disabled');
                            }
                            if (parseFloat($('.paid-cash-modal #total-value').text()) <= 0) {
                                $('.paid-cash-modal .paid-cash-btn').attr('disabled', 'disabled');
                            }
                        //}
                    }
                });
            }

            if (action == 'paid-cash') paymentRequest();
            else checkStripe(paymentRequest);

        });
    },

    createCharge(){
        //$('#additional_input').mask('999999.99');
        $('body').on('input','.manual-charge-modal #additional_input', (e) => {
            if ($(e.target).val()>0) {
                $('.manual-charge-modal .sub_total_manual').text(parseFloat($(e.target).val()).toFixed(2));
                if ($('[data-tax-percent]').length>0) {
                    $('.tax_value_manual').text(this.calculateTax($(e.target).val(), $('[data-tax-percent]').val()));
                    $('.total_value_manual').text((parseFloat($('.manual-charge-modal .sub_total_manual').text()) + parseFloat($('.tax_value_manual').text())).toFixed(2));
                }
                if($('.manual-charge-modal .customer-payment-warning').length == 0){
                    $('.manual-charge-modal .charge-btn').removeAttr('disabled');
                }
            } else {
                $('.manual-charge-modal .charge-btn').attr('disabled', 'disabled');
                $('.manual-charge-modal .sub_total_manual').text('0.00');
                $('.tax_value_manual').text('0.00');
                $('.total_value_manual').text('0.00');
            }
        });
        $('body').on('input','.charge-modal #additional_input, .service-invoice-modal #additional_input, .paid-cash-modal #additional_input', function() {
            let parentForm = '';
            let tips = 0, tax = 0, sub_total=0;
            if ($(this).parents('.modal-form').hasClass('charge-modal')) {
                parentForm = '.charge-modal';
            }else if($(this).parents('.modal-form').hasClass('paid-cash-modal')){
                parentForm = '.paid-cash-modal';
            }else {
                parentForm = '.service-invoice-modal';
            }


            sub_total = $('#sub_hidden_value').val();
            if ($(this).val()>0) {
                let val = parseFloat($(this).val()) + parseFloat($('#sub_hidden_value').val());
                $(`${parentForm} .service-estimate-pricing__sub-total-value`).text(val.toFixed(2));
                sub_total = val.toFixed(2);
            } else {
                $(`${parentForm} .service-estimate-pricing__sub-total-value`).text(sub_total);
            }

            if ($('[data-tax-percent]').length>0) {
                let new_tax = parseFloat($(`${parentForm} .service-estimate-pricing__sub-total-value`).text())*($('[data-tax-percent]').val()/100);
                $('.service-estimate-pricing__tax-value').text(new_tax.toFixed(2));
                tax = new_tax;
            }
            if ($('[data-sub-total-tips]').length>0) {
                tips = parseFloat($('[data-sub-total-tips]').text());
            }


            let total = parseFloat(sub_total) + tax + tips;
            $('.service-estimate-pricing__total-value').text(total.toFixed(2));
            if (total>0) {
                $('.charge-modal .charge-btn').removeAttr('disabled');
                if($('.paid-cash-modal .customer-payment-warning').length == 0){
                    $('.paid-cash-modal .paid-cash-btn').removeAttr('disabled');
                }
            }else{
                $('.charge-modal .charge-btn').attr('disabled', 'disabled');
                $('.paid-cash-modal .paid-cash-btn').attr('disabled', 'disabled');
            }
        });

        $('body').on('click', '.charge-btn, .paid-cash-btn', function(e) {
            e.preventDefault();

            let currentElem = $(this);
            let order_id = currentElem.data('order-id');
            let action = currentElem.data('action');
            let type = currentElem.data('type');
            let typeAction = currentElem.data('type-action')

            let additional_amount = $('#additional_input').val();
            let additional_comments = $('#payment_comments').val();

            let data = {
                type: type,
                additional_amount: additional_amount,
                additional_comments: additional_comments,
            };
            $('.charge-modal').modal('hide');
            $('.modal-backdrop').remove();
            $('.bb-preloader-container').show();
            $.ajax({
                type: 'POST',
                url: '/payments/' + order_id + '/' + action + (typeAction ? `/${typeAction}` : ''),
                data: data,
                success: function (response) {
                    if (action == 'paid-cash') {
                        window.location.reload();
                    }
                    $('.bb-preloader-container').hide();
                    $('#ajax_modals_containter').html(response);
                    $('#success_payment-modal').modal('show');
                    $('#failed_payment-modal').modal('show');
                }
            });
        });

        $('body').on('click', '.more-info-wrapper .view-payment-details.manager', function (e) {
            let type = $(this).data('type');
            $.ajax({
                method: 'POST',
                url: '/payments/get-form',
                data: {
                    form_type:  type,
                    payment_id: $(this).data('payment_id'),
                },
                success: function(response) {
                    $('#form-container').html(response);
                    $(`#customer-view-${type}-modal`).modal('show');
                }
            });
        });
    },

    calculateTax(sum, tax){
        if (sum >0 && tax>0) {
            let tax_value = sum*tax/100
            return parseFloat(tax_value).toFixed(2);
        }else{
            return '0.00'
        }
    },

    refunds() {
        $('body').on('click', '.refund-modal-btn', function(e) {
            e.preventDefault();

            let currentElem = $(this);
            let payment_id = currentElem.data('payment-id');
            let action = currentElem.data('action');

            $('.bb-preloader-container').show();
            $.ajax({
                type: 'GET',
                url: '/payments/' + payment_id + '/' + action,
                success: function (response) {
                    $('.bb-preloader-container').hide();
                    $('#ajax_modals_containter').html(response);
                    $('.'+action+'-modal').modal('show');
                },
                error: function(response) {
                    $('.bb-preloader-container').hide();
                    console.log(response);
                }
            });
        });

        $('body').on('click', '.refund-charge-btn', function(e) {
            e.preventDefault();

            let currentElem = $(this);
            let payment_id = currentElem.data('payment-id');
            let action = currentElem.data('action');

            let data = {
                refund_amount: $('#refund_amount_input').val(),
                refund_details: $('#refund_details').val(),
            };
            $('.modal-backdrop').remove();
            $('.bb-preloader-container').show();
            $.ajax({
                type: 'POST',
                url: '/payments/' + payment_id + '/' + action,
                data: data,
                success: function(response) {
                    $('.bb-preloader-container').hide();
                    $('#ajax_modals_containter').html(response.modal);
                    $('#success_payment-modal').modal('show');
                },
                error: function(response) {
                    $('.bb-preloader-container').hide();
                    $('.refund-form-modal .error-message').text(response.responseJSON.message);
                }
            });
        });
    },

    removeWarning(){
        $(document).on('click', '.remove_warning',function (e) {
            let class_id = $(this).data('class_id');
            let class_type = $(this).data('class_type');
            $.ajax({
                method: "POST",
                url: `/${class_type}/remove-warning`,
                data:{ class_id: class_id},
                success: function (response) {
                    location.reload(true);
                }
            });
        });
    },

    autoRefresh(pathname){
        if (window.location.pathname == pathname) {
            this.clearAllIntervals();
            let interval = setInterval(function () {
                location.reload(true);
            }, 900000);
        }
    },

    clearAllIntervals(){
        for(var i = setInterval(''); i >= 0; i--){
            clearInterval(i);
        }
    },

    initPagination(){
        let section;
        if (window.location.pathname == '/payments') {
            section = new Section('payments', true);
            section.show();
        } else if (window.location.pathname == '/subscription') {
            section = new Section('subscriptions', true);
            section.show();
        }
    }
}
